import { Appointment } from "../@data";

export const canCancelAppointment = (appointment: Appointment): boolean => {
  const now = Date.now();
  const appointmentTime = appointment.timestamp;

  if (appointmentTime <= now) {
    return false;
  }

  const oneHourInMs = 60 * 60 * 1000;
  const timeDifference = appointmentTime - now;

  return timeDifference >= oneHourInMs;
};
